export default __webpack_public_path__ + "static/media/poster16.aef64776.png";